import {
	EntityAzurePullRequestsContent,
	isAzureDevOpsAvailable,
} from "@backstage-community/plugin-azure-devops";
import {
	EntityConsumedApisCard,
	EntityProvidedApisCard,
} from "@backstage/plugin-api-docs";
import {
	EntityLayout,
	EntitySwitch,
	isComponentType,
} from "@backstage/plugin-catalog";
import {
	EntityKubernetesContent,
	isKubernetesAvailable,
} from "@backstage/plugin-kubernetes";
import {
	EntityLighthouseContent,
	isLighthouseAvailable,
} from "@backstage/plugin-lighthouse";
//import { EntityBitbucketPullRequestsContent } from '@roadiehq/backstage-plugin-bitbucket-pullrequest';
import { EntityGithubInsightsContent } from "@roadiehq/backstage-plugin-github-insights";

import {
	EntityAmazonEcsServicesContent,
	isAmazonEcsServiceAvailable,
} from "@aws/amazon-ecs-plugin-for-backstage";
import { TopologyPage } from "@janus-idp/backstage-plugin-topology";
import { Grid } from "@material-ui/core";
import { EntityGithubPullRequestsContent } from "@roadiehq/backstage-plugin-github-pull-requests";
import {
	EntityJiraOverviewCard,
	isJiraAvailable,
} from "@roadiehq/backstage-plugin-jira";
import {
	EntityPrometheusContent,
	isPrometheusAvailable,
} from "@roadiehq/backstage-plugin-prometheus";
import {
	EntityGrafanaDashboardsCard,
	EntityGrafanaAlertsCard,
	isDashboardSelectorAvailable,
} from "@k-phoen/backstage-plugin-grafana";
import React from "react";
import {
	cdContent,
	ciContent,
	dependenciesContent,
	imageRegistry,
	isCIsAvailable,
	isImageRegistriesAvailable,
	isMonitoringAvailable,
	monitoringContent,
	overviewContent,
	techdocsContent,
} from "../Content";
import { defaultEntityPage } from "./DefaultEntity";

const componentEntityPage = (componentType: "service" | "website") => (
	<EntityLayout>
		<EntityLayout.Route path="/" title="Overview">
			{overviewContent}
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isPrometheusAvailable}
			path="/prometheus"
			title="Prometheus"
		>
			<EntityPrometheusContent />
		</EntityLayout.Route>
		<EntityLayout.Route
			if={(entity) => Boolean(isDashboardSelectorAvailable(entity))}
			path="/grafana"
			title="Grafana"
		>
			<Grid container spacing={3} alignItems="stretch">
				<Grid item md={12}>
					<EntityGrafanaDashboardsCard />
				</Grid>
				<Grid item md={12}>
					<EntityGrafanaAlertsCard />
				</Grid>
			</Grid>
		</EntityLayout.Route>
		<EntityLayout.Route if={isCIsAvailable} path="/ci-cd" title="CI/CD">
			<>
				{ciContent}
				{cdContent}
			</>
		</EntityLayout.Route>
		{/* Commenting out the bitbucket pull requests 
    <EntityLayout.Route path="/bitbucket-pullrequests" title="Bitbucket">
      <EntityBitbucketPullRequestsContent />
    </EntityLayout.Route>
    */}
		<EntityLayout.Route path="/code-insights" title="Code Insights">
			<EntityGithubInsightsContent />
		</EntityLayout.Route>
		<EntityLayout.Route path="/pull-requests" title="Pull Requests">
			<EntityGithubPullRequestsContent />
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isAzureDevOpsAvailable}
			path="/pull-requests"
			title="Pull Requests"
		>
			<EntityAzurePullRequestsContent defaultLimit={25} />
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isKubernetesAvailable}
			path="/topology"
			title="Topology"
		>
			<TopologyPage />
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isKubernetesAvailable}
			path="/kubernetes"
			title="Kubernetes"
		>
			<EntityKubernetesContent refreshIntervalMs={30000} />
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isAmazonEcsServiceAvailable}
			path="/ecs"
			title="Amazon ECS"
		>
			<EntityAmazonEcsServicesContent />
		</EntityLayout.Route>
		<EntityLayout.Route if={isJiraAvailable} path="/jira" title="Jira">
			<Grid container spacing={3} alignItems="stretch">
				<Grid item md={12}>
					<EntityJiraOverviewCard />
				</Grid>
			</Grid>
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isImageRegistriesAvailable}
			path="/image-registry"
			title="Image Registry"
		>
			{imageRegistry}
		</EntityLayout.Route>
		<EntityLayout.Route
			if={isMonitoringAvailable}
			path="/monitoring"
			title="Monitoring"
		>
			{monitoringContent}
		</EntityLayout.Route>
		<EntityLayout.Route
			path="/lighthouse"
			title="Lighthouse"
			if={isLighthouseAvailable}
		>
			<EntityLighthouseContent />
		</EntityLayout.Route>
		{componentType === "service" && (
			<EntityLayout.Route path="/api" title="API">
				<Grid container spacing={3}>
					<Grid item md={6}>
						<EntityProvidedApisCard />
					</Grid>
					<Grid item md={6}>
						<EntityConsumedApisCard />
					</Grid>
				</Grid>
			</EntityLayout.Route>
		)}
		<EntityLayout.Route path="/dependencies" title="Dependencies">
			{dependenciesContent}
		</EntityLayout.Route>
		<EntityLayout.Route path="/docs" title="Docs">
			{techdocsContent}
		</EntityLayout.Route>
	</EntityLayout>
);
export const componentPage = (
	<EntitySwitch>
		<EntitySwitch.Case if={isComponentType("service")}>
			{componentEntityPage("service")}
		</EntitySwitch.Case>

		<EntitySwitch.Case if={isComponentType("website")}>
			{componentEntityPage("website")}
		</EntitySwitch.Case>

		<EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
	</EntitySwitch>
);
